import axios from '../request/http';

const setting = {
    // 修改密码
    updatePassword(params) {
        return axios.get("/admin/admin-info/update-password", {params});
    },
    // 修改基本信息
    updateBaseInfo(params) {
        return axios.get("/admin/admin-info/update-baseInfo", {params});
    },
    // 收益设置
    revenueSetting(data) {
        return axios.post("/admin/admin-set/income-set", data);
    },
    // 积分规则
    integralRule(data) {
        return axios.post("/admin/admin-set/integralRule", data);
    },
    // 用户设置
    userUpdate(data) {
        return axios.post("/admin/admin-set/user-set", data);
    },
    // 关于为们
    settingAboutUs(data) {
        return axios.post("/admin/admin-set/aboutUs", data);
    },
    // 修改角色组权限信息
    rolesGroupEdit(params) {
        return axios.get("/admin/roles/rolesGroupEditOrAdd", {params});
    },
    // 获取所有路由信息
    routeList(params) {
        return axios.get("/admin/roles/routesInfo", {params});
    },
    // 新增路由
    routeAdd(data) {
        return axios.post("/admin/roles/routeAddOrEdit", data);
    },
    // 路由状态
    routeDel(params) {
        return axios.get("/admin/roles/routeStatus", {params});
    },
    // 路由删除
    routeDl(params) {
        return axios.get("/admin/roles/routeDel", {params});
    },
    // 团队长会员权益
    leaderSet(data) {
        return axios.post("/admin/admin-set/equityRule", data);
    },
    // 平台配置信息
    adminSetInfo(params) {
        return axios.get("/admin/admin-set/info", {params});
    },
    // 商城订单分佣比例规则
    marketGoodsShareRule(data) {
        return axios.post("/admin/admin-set/marketGoodsShareRule", data);
    },
}

export default setting;


// WEBPACK FOOTER //
// ./src/api/setting.js